import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "en", label: "EN", full: "English" },
  { code: "es", label: "ES", full: "Español" },
  { code: "pt", label: "PT", full: "Português" },
];

export function LanguagePill() {
  const { lang, setLang } = useI18n();
  const { user, updateUser } = useAuth();

  const choose = async (code) => {
    setLang(code);
    if (user) {
      try {
        const res = await api.put("/profile", { language: code });
        updateUser(res.data);
      } catch {}
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-pill"
          className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-600 card-shadow hover:bg-slate-50 transition-colors"
        >
          <Globe className="h-4 w-4 text-brandblue" />
          <span>
            {LANGS.map((l, i) => (
              <span key={l.code} className={l.code === lang ? "text-brandblue font-semibold" : ""}>
                {l.label}{i < LANGS.length - 1 ? " / " : ""}
              </span>
            ))}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-${l.code}`} onClick={() => choose(l.code)}
            className={l.code === lang ? "font-semibold text-brandblue" : ""}>
            {l.full}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
